import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import EnquiryForm from "../../Components/EnquiryForm";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function WebDevelopment(){
    useEffect(() => {
        sal();
    }, []);
    return(
        <>
        <Helmet>
            <title>Trusted Website Development Experts | Scalable Web Solutions</title>
            <meta name="description" content="Get professional website development services to build fast, responsive, and SEO-friendly websites. Our expert developers create secure and scalable web solutions." />
            <meta name="keywords" content="Website Development Company, Web Development Company, Web Development Services, Web Design and Development, Web Development Agency, Website Development Costs, Best Website Developers, Best Web Design Companies, Top Web Development Companies, Web Design and Development Agency" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/website-development`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/website-development`} />
            <meta property="og:title" content="Best Custom Website Development Solutions | Infinitive Host" />
            <meta property="og:description" content="Infinitive Host delivers professional website development services to create visually stunning, fast, and scalable websites that enhance brand presence and user experience." />
        </Helmet>
            <section className="hero-1 pb-32 bg-dark position-relative z-1 overflow-hidden">
                <div className="container banner-wrapper">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-7">
                            <div className="fs-14 text-white">
                                <div className="d-flex align-items-center gap-3" data-sal="fade" data-sal-duration="500"
                                    data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                    <span><i className='fa-solid fa-star text-warning' style={{fontSize: '22px'}}></i></span>
                                    <span>
                                        Your Site’s Glow-Up
                                    </span>
                                </div>
                            </div>
                            <h1 className="text-white mt-1" data-sal="fade" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">Web Development Services   
                                <span className="text-warning d-inline-block">.</span>
                                That Make Your Site Go “Ohhh Wow.” 
                            </h1>
                            <p className="text-white mt-5 max-text-68 mb-8" data-sal="fade" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">When people check out your site, the first few seconds decide whether they will stay or not. They just walk away if it seems ordinary or a little confusing. Our web development services always make your site smooth, engaging, and worth exploring.</p>
                        </div>
                        <div className="col-lg-5 ipad-mt">
                            < EnquiryForm />
                        </div>
                    </div>
                </div>
            </section>
            
            <div className="pt-100 pb-100 bg-opacity-5">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-xxl-5 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Hidden Site Challenges</small>
                            <h2 className="h3 mb-3">
                                Signs That Your Website Really Needs an Upgrade
                            </h2>
                            <p className="mb-8 max-text-48">
                                Visitors decide instantly. If your site doesn’t engage them in seconds, they simply move on. Advanced website development turns those visits into great opportunities.
                            </p>
                        </div>
                        <div className="col-xxl-7">
                            <div className="row g-4">
                                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <div className="card hover-shadow rounded-3 border border-secondary transition">
                                        <div className="card-body p-xl-6">
                                            <div className="mb-4">
                                                <img src="images/outdated-website.webp" alt="icon" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Outdated Website? 
                                            </h6>
                                            <p className="mb-0">If your site sometimes feels stuck in the past, the audience notices it in no time. A fresh website development strategy can give your business the real glow-up it deserves and make everyone think, “Ok… this looks wow.”</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <div className="card hover-shadow rounded-3 border border-secondary transition">
                                        <div className="card-body p-xl-6">
                                            <div className="mb-4">
                                                <img src="images/slow-website.webp" alt="icon" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                    Slow Website? 
                                            </h6>
                                            <p className="mb-0">At present, no one loves to wait for so long. If your web pages take too much time to load, viewers bounce even before checking out what you offer. Our web development services always keep things smooth and productive.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <div className="card hover-shadow rounded-3 border border-secondary transition">
                                        <div className="card-body p-xl-6">
                                            <div className="mb-4">
                                                <img src="images/losing-visitors.webp" alt="icon" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Losing Visitors? 
                                            </h6>
                                            <p className="mb-0">When targeted visitors land on your site but can’t simply find what they wish for, the vibe just breaks in a blink. Exceptional website development solutions make your website smooth enough to explore and keep visitors engaged.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <div className="card hover-shadow rounded-3 border border-secondary transition">
                                        <div className="card-body p-xl-6">
                                            <div className="mb-4">
                                                <img src="images/web-mobile-friendly.webp" alt="icon" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                               Mobile Friendly? 
                                            </h6>
                                            <p className="mb-0">Most of the visitors are using their phones for exploring. If your site doesn’t look perfect on smartphones, it’s a big vibe killer. Our web development services make sure that your website simply works perfectly everywhere, 24/7.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="pb-100">
                <div className="container">
                    <div className="bg-white px-8 py-10 rounded-3">
                        <div className="row align-items-center g-4">
                            <div className="col-lg-5">
                                <img src="/images/your-business-called.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                            </div>
                            <div className="col-lg-7 ipad-mt">
                                <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                                    <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Websites That Grab Attention!!!
                                    </small>
                                </div>
                                <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Umm… Your Business Called. It Wishes for an Advanced Website.</h2>
                                <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> A highly experienced web development agency with proven results helps your business show up online with a fresh site that builds trust and brings the perfect vibe.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="why-choose-section pt-100 pb-100">
                <div className="pb-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 col-lg-8 col-xl-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <span className="d-flex align-items-center gap-2 mb-3">
                        <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                                <span className="d-block text-white">
                        <span className="text-success">Our Tech</span> Gameplay
                                </span>
                                </span>
                                <h2 className="mb-2 text-white">
                                    No More Outdated Tools With Us. Just Advanced Tech.
                                </h2>
                                <div className="text-white">
                                    <p>Behind our reliable web development services is all the advanced tech that keeps your site running flawlessly, looking engaged, and really hitting different.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row g-4 align-items-center justify-content-xl-between">
                        <div className="col-lg-4 col-xxl-4">
                            <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <img src="/images/no-more outdated-tools.webp" alt="image" className="img-fluid"/>
                            </div>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-xxl-4">
                            <ul className="list-unstyled vstack gap-4">
                                <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate d-flex">
                                    <div className="cloud-card h-100 w-100">
                                        <h6 className="cloud-card__title mb-4">Frontend Technologies</h6>
                                        <p className="mb-0 fs-14">
                                            We always go for advanced frontend tech to create sites that look flawless and feel pleasing.
                                        </p>
                                        <div className="row mt-2">
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>JavaScript</li>
                                                    <li>HTML5</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>CSS3</li>
                                                    <li>React</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate d-flex">
                                    <div className="cloud-card h-100 w-100">
                                        <h6 className="cloud-card__title mb-4">Backend Technologies</h6>
                                        <p className="mb-0 fs-14">
                                            Exceptional backend technologies simply keep your site quick, stable, and secure.
                                        </p>
                                        <div className="row mt-2">
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>Python</li>
                                                    <li>Node.js</li>
                                                    <li>Express</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>Next.js</li>
                                                    <li>PHP</li>
                                                    <li>Laravel</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-xxl-4">
                            <ul className="list-unstyled vstack gap-4">
                                <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate d-flex">
                                    <div className="cloud-card h-100 w-100">
                                        <h6 className="cloud-card__title mb-4">Database Technologies</h6>
                                        <p className="mb-0 fs-14">
                                            Powerful databases that help to manage and keep your website’s data productively.
                                        </p>
                                        <div className="row mt-2">
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>MySQL</li>
                                                    <li>PostgreSQL</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>SQLite</li>
                                                    <li>MongoDB</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate d-flex">
                                    <div className="cloud-card h-100 w-100">
                                        <h6 className="cloud-card__title mb-4">Tools and Platforms</h6>
                                        <p className="mb-0 fs-14">
                                            All the modern tools help us build, handle, and deploy all websites flawlessly.
                                        </p>
                                        <div className="row mt-2">
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>Git / GitHub</li>
                                                    <li>GitLab</li>
                                                    <li>BitBucket</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6 col-xl-5 col-xxl-4">
                                                <ul className="list-unstyled">
                                                    <li>Docker</li>
                                                    <li>Google Cloud</li>
                                                    <li>AWS</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

             <section className="service-area pt-100 pb-100">
                <div className="pb-40">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-7">
                                <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Got Site’s Dream? Our Web Development Solutions Bring Them to Reality.</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Inventory System</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img src="images/inventory-system.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>An inventory system helps you flawlessly track and handle all your stock in real time. It decreases the chances of unexpected errors and shortages and keeps your brand running seamlessly.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>ERP</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img src="images/erp.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>An ERP-based system helps bring each of your brand processes into one place. Ranging from different processes to reporting, it keeps everything systematic, so your experts can work smartly.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>CMS</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/cms.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>A CMS (Content Management System) makes it quite easy to update and handle your site content, 24/7. No technical struggles, just quick access to your web pages, blogs, and social media.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Ecommerce</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/ecommerce.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>An e-commerce platform always helps you sell all your products online with ease. It develops a seamless shopping experience that keeps clients constantly searching and purchasing, anytime.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>CRM</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/crm.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>A CRM system always helps you handle customer relationships smoothly. Ranging from tracking different interactions to enhancing communication, it helps turn quality leads into clients.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
                <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
                <div className="pb-40">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-10 col-lg-8 col-xl-7">
                                <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <span className="section-title-dark style-bg fadeInUp">Industries</span>
                                    <h2 className="text-white">
                                        Different Industries. Different Visions. One Attractive Website.
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container all-feature-container">
                    <div className="row">
                    <div className="col-12">
                        <div className="feature-tabbing-main mt-4">
                            <div className="row">
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>E-commerce</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>E-Learning Platforms</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Travel & Hospitality</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Finance & FinTech</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Food Delivery</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Healthcare</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Logistics & Transportation</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Real Estate</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-2">
                                <div className="feature-wrapper h-100">
                                    <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Media & Entertainment</p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                </div>
                </div>
            </section>

            <section className="service-area pt-20 pb-100">
                <div className="pb-40">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-7">
                                <h3 className="mb-0" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                    data-sal-easing="ease-in-out-sine">The Journey From Having a Website to Having One in Real Life</h3>
                                <p className="mt-3">Our web development services help all brands across different industries to get their dream website that enhances productivity, customer engagement, and growth.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row justify-content-center g-4">
                        <div className="col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                    <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                                <div className="card-body px-md-7 py-md-8">
                                    <div className="row align-items-center g-4 d-grid">
                                        <div className="col-md-4">
                                            <img className="service-img" src="images/information-gathering.webp" alt="" />
                                        </div>
                                        <div className="col-md-12">
                                            <h6 className="mb-4">Information Gathering</h6>
                                            <p className="mb-5 pb-2">Our BA team directly contacts the client to know about their website requirements, project expectations, and goals.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                                <div className="card-body px-md-7 py-md-8">
                                    <div className="row align-items-center g-4 d-grid">
                                        <div className="col-md-4">
                                            <img className="service-img" src="images/requirement-review-and-analysis.webp" alt="" />
                                        </div>
                                        <div className="col-md-12">
                                            <h6 className="mb-4">Requirement Review & Analysis</h6>
                                            <p className="mb-5 pb-2">Both the project manager and the BA go through all the provided requirements to work on scope, practicality, project flow, and timeline.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Project Documentation</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/project-documentation.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>According to the discussions with the client, the BA creates thorough documentation that focuses on all the points mentioned in the meeting.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Development Stage</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/development-stage.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>At this phase, our highly experienced developers design and develop the required website by focusing completely on the frontend, backend, and all other processes.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>UI/UX Design</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/ui-ux-design.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>The graphic design team crafts visually attractive and highly engaging designs to make sure that all interested visitors get a smooth experience.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Content Creation</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/content-creation.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>After that, our SEO-friendly content writer writes content that clearly communicates the message of your brand to engage more visitors.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Quality Testing</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/quality-testing.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>The QA team carefully tests the whole site multiple times once it's developed, checks out available bugs, and makes sure that everything works in the right way.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Bug Fixing</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/bug-fix.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Our development team then troubleshoots all problems that are reported by the QA team and prepares the first stable version for User Acceptance Testing (UAT).</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Client Testing (UAT)</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/uat.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>The site is then finally shared with the client for different testing and verification, making sure that it meets all requirements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                                data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Final Handover</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img className="small-service-img" src="images/final-handover.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>After the client’s approval, the whole project is successfully delivered to the client, all set to go live.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container pb-100">
                <div className="bg-dark pt-40 pb-40 px-8 px-md-14 rounded-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row align-items-center g-4">
                        <div className="col-xxl-6 col-xl-4 col-lg-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <img src="images/whats-for-you-on-Infinitive-host.webp" alt="image" className="img-fluid" />
                        </div>
                        <div className="col-xxl-6 col-xl-8 col-lg-7">
                            <h2 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Infinitive Host: Where Exceptional Websites Get Designed</h2>
                            <p className="text-white text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Behind all standout businesses is unbeatable website development-turning dream ideas into real-time experiences and site visitors into customers.</p>
                            <div className="mt-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comments"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Live Chat Now
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}